import { Link } from 'react-scroll';
import styled from 'styled-components';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from '../../../theme';

export const StyledOfferSummary = styled.div`
  margin-top: ${spacing('xl')};
  margin-bottom: ${spacing('xl')};
  padding-top: ${spacing('sm')};
  padding-bottom: ${spacing('sm')};
  border-top: 1px solid ${color('midnight_200')};
  border-bottom: 1px solid ${color('midnight_200')};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const StyledOfferSummaryItem = styled.div`
  padding-right: ${spacing('lg')};
  margin-top: ${spacing('xs')};
  margin-bottom: ${spacing('xs')};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: center;

  @media (min-width: ${screen('md')}) {
    margin-top: ${spacing('sm')};
    margin-bottom: ${spacing('sm')};
    padding-left: ${spacing('lg')};
    padding-right: ${spacing('lg')};
  }

  @media (min-width: ${screen('lg')}) {
    padding-left: ${spacing('xl')};
    padding-right: ${spacing('xl')};
  }
`;

export const StyledOfferSummaryBlock = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: center;

  @media (min-width: ${screen('md')}) {
    flex-wrap: nowrap;
  }

  ${StyledOfferSummaryItem}:first-child {
    @media (max-width: ${screen('mdMax')}) {
      padding-left: 0;
    }
  }
`;

export const StyledOfferSummaryItemTitle = styled.h3`
  font-size: ${fontSize('md')};
  font-weight: ${fontWeight('black')};
  color: ${color('text_subtle')};
  text-transform: uppercase;
  line-height: 1;
  margin-top: 0;
  margin-bottom: ${spacing('xs')};
`;

export const StyledOfferSummaryItemValue = styled(Link)`
  font-family: ${fontFamily('display')};
  font-size: ${fontSize('xl4')};
  font-weight: ${fontWeight('light')};
  text-transform: uppercase;
  line-height: 1;
  white-space: nowrap;
  span {
    color: ${color('text_placeholder')};

    &.extra {
      color: ${color('text_default')};
    }
  }
  strong {
    font-weight: ${fontWeight('semiBold')};
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('xl6')};
  }
`;

export const StyledOfferSummaryItemExtra = styled.span`
  font-size: ${fontSize('sm')};
  font-weight: ${fontWeight('black')};
  color: ${color('text_subtle')};
  margin-top: ${spacing('xs2')};
`;
